/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function clearSearchBar() {
  document.getElementsByClassName("header-search__input")[0].value = "";
}

window.addEventListener("videeo:add-to-cart", videeoAddToCartEventHandler);
function videeoAddToCartEventHandler() {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
    })
  );
  var cartDrawerButtonSelector =
    "Header__Icon Icon-Wrapper Icon-Wrapper--clickable ";
  var cartDrawerButton = document.getElementsByClassName(
    cartDrawerButtonSelector
  )[4];
  cartDrawerButton.click();
}

function chkX() {
  var element = document.getElementById("agrAbve");
  if (element.checked == true) {
    document.getElementById("agrAbveBtn").disabled = false;
    document.getElementById("agrAbveBtn").classList.remove("Button--disabled");
  } else {
    document.getElementById("agrAbveBtn").disabled = true;
    document.getElementById("agrAbveBtn").classList.add("Button--disabled");
  }
}

function myFpTrLL($event, $id, $variantID) {
  console.log("added" + $id);
  console.log("added" + $variantID);
  // Get the checkbox
  var checkBox = document.getElementById($id + "Check");
  if (checkBox.checked == true) {
    var addData = { quantity: 1, id: $variantID };
    fetch("/cart/add.js", {
      body: JSON.stringify(addData),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With":
          "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
      },
      method: "POST",
    })
      .then(function (response) {
        if (response.ok) {
          var node = document.createElement("p"); // Create a <li> node
          var textnode = document.createTextNode("Thank you!");
          node.appendChild(textnode); // Create a text node
          document.getElementById($id + "-thx").appendChild(node);
          setTimeout(function () {
            window.location.href = "/cart";
          }, 1000);
        } else {
          console.log(response);
        }
      })
      .then((data) => {
        return data;
      });
  }
}

// $(".announcement_carousel").flickity({
//     wrapAround: true,
//     freeScroll: true,
//     pageDots: false,
//     prevNextButtons: false,
//     autoPlay: 3000,
//   });

//  setTimeout(function() {
// $(".video-slider").flickity({
//   contain: true,
//   wrapAround: false,
//   freeScroll: true,
//   pageDots: true,
//   prevNextButtons: false,
//   watchCSS: false,
//   dragThreshold: 8,
//   groupCells: true,
//   arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25},
// });
//  },500);

// $('.membership-product-carousel').flickity({
//   cellAlign: 'center',
//   contain: true,
//   wrapAround: false,
//   freeScroll: true,
//   pageDots: true,
//   prevNextButtons: true,
//   watchCSS: false,
//   dragThreshold: 8,
//   groupCells: true,
//   arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25},
// });

//dropdown js
var timeSelected = "";
var countrySelected = "";
$(".opportunities-sec .country-select [name=country_id]").on(
  "change",
  function () {
    countrySelected = $(this).val();
    if (timeSelected) {
      $(".opportunities-items").hide();
      $(
        '.opportunities-items[data-location="' +
          countrySelected +
          '"][data-contract="' +
          timeSelected +
          '"]'
      ).show();
    }
    if (countrySelected == "0" && timeSelected == "0") {
      $(".opportunities-items").show();
    }
  }
);

$(".opportunities-sec .time-select [name=time_id]").on("change", function () {
  timeSelected = $(this).val();
  $(".opportunities-items").hide();
  $(
    '.opportunities-items[data-location="' +
      countrySelected +
      '"][data-contract="' +
      timeSelected +
      '"]'
  ).show();
  if (countrySelected == "0" && timeSelected == "0") {
    $(".opportunities-items").show();
  }
});

//product carousel
// $('.product-list-flickity-carousel').flickity({
//   cellAlign: 'center',
//   contain: true,
//   wrapAround: false,
//   freeScroll: true,
//   pageDots: false,
//   prevNextButtons: true,
//   dragThreshold: 8,
//   groupCells: 4,
//   arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25},
// });

$(".announcement_carousel").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  dots: false,
  infinite: true,
  speed: 1000,
});

$(".video-slider").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  dots: true,
  infinite: false,
  arrows: false,
  prevArrow:
    '<i class="slick-prev-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></i>',
  nextArrow:
    '<i class="slick-next-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></i>',
  responsive: [
    {
      breakpoint: 1140,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1008,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 642,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(".membership-product-carousel").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  dots: true,
  infinite: false,
  arrows: true,
  prevArrow:
    '<i class="slick-prev-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></i>',
  nextArrow:
    '<i class="slick-next-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></i>',
  responsive: [
    {
      breakpoint: 1501,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1008,
      settings: {
        slidesToShow: 2,
        arrows: false,
      },
    },
  ],
});
$(".product-list-carousel").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  dots: true,
  infinite: false,
  arrows: true,
  prevArrow:
    '<i class="slick-prev-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></i>',
  nextArrow:
    '<i class="slick-next-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></i>',
  responsive: [
    {
      breakpoint: 1140,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1008,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 642,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(document).one("click", ".live-shopping-btn .button", function () {
  setTimeout(function(){
    $(".how_to_use_mobile_slider").slick({
      centerMode: true,
      centerPadding: '180px',
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      arrows: false,
      responsive: [
         {
          breakpoint: 910,
          settings: {
            centerPadding: '200px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 800,
          settings: {
            centerPadding: '180px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            centerPadding: '160px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 641,
          settings: {
            centerPadding: '140px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 575,
          settings: {
            centerPadding: '100px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 500,
          settings: {
            centerPadding: '80px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 426,
          settings: {
            centerPadding: '40px',
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 374,
          settings: {
            centerPadding: '10px',
            slidesToShow: 1,
          },
        },
      ],
    });
  }, 500);
});

// opportunuty page js
$(".TestimonialList").slick({
  arrows: false,
  autoplay: true,
  centerMode: false,
  infinite: true,
  rows: 0,
  slidesToShow: 1,
  vertical: true,
  verticalSwiping: true,
  slidesToScroll: 1,
  dots: false,
  easing: "linear",
  cssEase: "linear",
  infinite: false,
});

function chkX() {
  var element = document.getElementById("agrAbve");
  if (element.checked == true) {
    document.getElementById("agrAbveBtn").disabled = false;
    document.getElementById("agrAbveBtn").classList.remove("button-disabled");
  } else {
    document.getElementById("agrAbveBtn").disabled = true;
    document.getElementById("agrAbveBtn").classList.add("button-disabled");
  }
}
$(document).ready(function() {
  if ($(this).scrollTop() > 100) {
    $(':has(.shopify-section:first-child [allow-transparent-header]):not(:has(.shopify-section--header+.shopify-section-group-header-group)) .header:not(:hover,:has([open]))').addClass('sticky_header');
  } else {
    $(':has(.shopify-section:first-child [allow-transparent-header]):not(:has(.shopify-section--header+.shopify-section-group-header-group)) .header:not(:hover,:has([open]))').removeClass('sticky_header');
  }
});
$(window).scroll(function() {
  if ($(this).scrollTop() > 100) {
    $(':has(.shopify-section:first-child [allow-transparent-header]):not(:has(.shopify-section--header+.shopify-section-group-header-group)) .header:not(:hover,:has([open]))').addClass('sticky_header');
  } else {
    $(':has(.shopify-section:first-child [allow-transparent-header]):not(:has(.shopify-section--header+.shopify-section-group-header-group)) .header:not(:hover,:has([open]))').removeClass('sticky_header');
  }
});

/* ===================== loose stone option ===================== */
document.addEventListener("DOMContentLoaded", function () {
  function isCartPage() {
    return window.location.pathname === "/cart";
  }

  function checkSelection() {
    const wrappers = document.querySelectorAll('[data-loose-stone="true"]');
    const checkoutBtns = document.querySelectorAll(`button[name="checkout"], .cart__checkout, .cart-drawer__footer button[name="checkout"], .cart-page button[name="checkout"]`);
    let allSelected = true;
    wrappers.forEach((wrapper) => {
      const radios = wrapper.querySelectorAll('input[type="radio"]');
      let isChecked = false;

      radios.forEach((radio) => {
        if (radio.checked) {
          isChecked = true;
        }
      });
      if (!isChecked) {
        allSelected = false;
      }
    });

    checkoutBtns.forEach((btn) => {
      btn.disabled = !allSelected;
    });
  }

  // ───────────────────────────────────── // RADIO CHANGE // ───────────────────────────────────── //
  document.addEventListener("change", async function (e) {
    if (!e.target.matches('[data-loose-stone="true"] input[type="radio"]')) {
      return;
    }

    const wrapper = e.target.closest('[data-loose-stone="true"]');
    const itemKey = wrapper?.dataset?.key;
    const value = e.target.value;
    if (!itemKey) return;
    try {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", {
          bubbles: true
        })
      );

      const lineItem = wrapper.closest("line-item");
      lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", {
          bubbles: true,
          detail: {
            stonePreference: value
          }
        })
      );

      // ───────────────────────────────────── // PREPARE BUNDLED SECTIONS // ───────────────────────────────────── //
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: {
            sections: sectionsToBundle
          }
        })
      );

      // ───────────────────────────────────── // CART CHANGE // ───────────────────────────────────── //
      const existingProperties = {};
      if (wrapper.dataset.properties) {
        const parsedProperties = JSON.parse(wrapper.dataset.properties);
        Object.entries(parsedProperties).forEach(([key, val]) => {
          if (Array.isArray(val) && val.length === 2) {
            existingProperties[val[0]] = val[1];
          } else {
            existingProperties[key] = val;
          }
        });
      }

      const cartContent = await (
        await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: wrapper.dataset.quantity || 1,
            properties: {
              ...existingProperties,
              "Stone Preference": value
            },
            sections: sectionsToBundle.join(",")
          })
        })
      ).json();
      
      if (isCartPage()) {
        window.location.reload();
        return;
      }

      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", {
          bubbles: true
        })
      );

      // ───────────────────────────────────── // FIND UPDATED ITEM AND LINE ITEM CHANGE // ───────────────────────────────────── //
      const lineItemAfterChange = cartContent.items.filter((item) => item.key === itemKey);
      lineItem?.dispatchEvent(
        new CustomEvent("line-item:change", {
          bubbles: true,
          detail: {
            quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0].quantity,
            cart: cartContent
          }
        })
      );

      // ───────────────────────────────────── // CART CHANGE EVENT // ───────────────────────────────────── //
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "line-item:change",
            cart: cartContent
          }
        })
      );

      // ───────────────────────────────────── // RECHECK AFTER AJAX UPDATE // ───────────────────────────────────── //
      setTimeout(() => {
        checkSelection();
      }, 100);
    } catch (err) {
      console.log("Cart update error:", err);
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", {
          bubbles: true
        })
      );
    }
  });

  // ───────────────────────────────────── // INITIAL CHECK // ───────────────────────────────────── //
  checkSelection();
  setTimeout(() => {
    checkSelection();
  }, 300);

  // ───────────────────────────────────── // CART DRAWER / AJAX EVENTS // ───────────────────────────────────── //
  document.documentElement.addEventListener("cart:change", () => {
    setTimeout(() => {
      checkSelection();
    }, 100);
  });

  document.addEventListener("cart:refresh", () => {
    setTimeout(() => {
      checkSelection();
    }, 100);
  });

  // ───────────────────────────────────── // OBSERVER // ───────────────────────────────────── //
  const observer = new MutationObserver(() => {
    checkSelection();
  });

  const cartDrawer = document.querySelector("cart-drawer");
  const cartPage = document.querySelector(".cart-page");

  if (cartDrawer) {
    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  if (cartPage) {
    observer.observe(cartPage, {
      childList: true,
      subtree: true
    });
  }
});
/* ===================== END loose stone option ===================== */